import { Component, HostBinding } from '@angular/core';
import { OpportunityModel } from 'src/models/mongo/opportunity.model';
import { UserModel } from 'src/models/mongo/user.model';
import { HttpRequestService } from 'src/servcies/http-request-service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Endpoint, Group, Unicode } from 'src/shared/Endpoint';
import { UntypedFormGroup } from '@angular/forms';
import { LocalStorageService } from 'src/servcies/localstorage-service';
import { ActivatedRoute, Router } from '@angular/router';
import { Utilities } from 'src/shared/utilities';
import { Location } from '@angular/common';

@Component({
  selector: 'lib-poc-list',
  templateUrl: './poc-list.component.html',
  styleUrls: ['./poc-list.component.scss'],
})
export class PocListComponent {
  @HostBinding('class') class = ' ';
  opportunities: OpportunityModel[] = [];
  plans = [];
  currentUser: UserModel;
  static _httpRequestService: HttpRequestService;
  static _http: HttpClient;
  customerSearch: string;
  fromSelectedDate;
  toSelectedDate;
  static pageSize: number = Unicode.ITEMS_PER_PAGE;
  static opportunities = [];
  static pocs = [];
  static pagination: number = 1;
  static total: number = 1;
  static gcp: boolean;
  selectedFilterType: string = 'ALL';
  types = ['ALL', 'GWS', 'GCP'];
  customerRfId;
  initial_userIds = [];
  add: boolean = true;
  assignsales = [];
  selectedUserId;
  selectedSales: string;
  pocForm: UntypedFormGroup;
  domainRfId;

  constructor(
    private http: HttpClient,
    private httpRequestService: HttpRequestService,
    private localStorage: LocalStorageService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location
  ) {
    //
    PocListComponent._httpRequestService = httpRequestService;
    PocListComponent._http = http;
    PocListComponent.gcp = false;
    var current = new Date();
    var beforeOneMonth = current.setMonth(current.getMonth() - 1);
    this.fromSelectedDate = new Date(beforeOneMonth).toISOString().slice(0, 10);
    this.toSelectedDate = new Date().toISOString().slice(0, 10);
  }

  async ngOnInit(): Promise<void> {
    this.assignsales = await Utilities.usersByGroup(
      Group.ENGINEER,
      this.http,
      this.localStorage
    );
    this.currentUser = JSON.parse(this.localStorage.getLoggedinUser());
    PocListComponent.pagination = 1;
    this.getpocs(null);
  }

  async getpocs(pagination) {
    if (pagination == null) pagination = PocListComponent.pagination;
    var prs = new HttpParams()
      .set(Unicode.PAGE, (pagination - 1) * PocListComponent.pageSize + '')
      .set(Unicode.LIMIT, PocListComponent.pageSize + '')
      .set(Unicode.POC_TYPE, this.selectedFilterType)
      .set(Unicode.VIEW_ALL, this.currentUser.canViewAll);
    if (!Utilities.isNullOrEmpty(this.customerSearch))
      prs = prs.set(Unicode.CUSTOMER_FILTER, this.customerSearch);
    if (!Utilities.isNullOrEmpty(this.fromSelectedDate))
      prs = prs.set(Unicode.FROM_DATE, this.fromSelectedDate);
    if (!Utilities.isNullOrEmpty(this.toSelectedDate))
      prs = prs.set(Unicode.TO_DATE, this.toSelectedDate);
    if (!Utilities.isNullOrEmpty(this.selectedSales))
      prs = prs.set(Unicode.SALES_MANAGER, this.selectedSales);
    await PocListComponent._http
      .get<any>(Endpoint.API_URL + '' + Endpoint.GET_ALL_POCS, {
        params: prs,
      })
      .toPromise()
      .then((resp) => {
        if (resp) {
          PocListComponent.total = <number>resp['total'];
          PocListComponent.pocs = resp.pocs ?? [];
        }
      });
  }

  renderPage(event: number) {
    PocListComponent.pagination = event;
    this.getpocs(null);
  }

  search() {
    PocListComponent.pagination = 1;
    this.getpocs(null);
  }
  selectDate() {
    PocListComponent.pagination = 1;
    this.getpocs(null);
  }
  selectSale() {
    PocListComponent.pagination = 1;
    this.getpocs(null);
  }
  selectStatus() {
    PocListComponent.pagination = 1;
    this.getpocs(null);
  }

  switchType(e) {
    e.target.classList.toggle('toggled');
    PocListComponent.pagination = 1;
    PocListComponent.gcp = !PocListComponent.gcp;
    this.getpocs(null);
  }

  applyFilter(type: string): void {
    if (type != this.selectedFilterType) {
      PocListComponent.pagination = 1;
      this.selectedFilterType = type;
      this.getpocs(null);
    }
  }

  get GetData() {
    return PocListComponent.pocs;
  }
  get GetTotalCount() {
    return PocListComponent.total;
  }
  get GetPagination() {
    return PocListComponent.pagination;
  }
  get GetPageSize() {
    return PocListComponent.pageSize;
  }
  async assignSales(selectedUser: any) {
    if (
      !this.add &&
      !Utilities.isNullOrEmpty(this.domainRfId) &&
      !Utilities.isNullOrEmpty(this.pocForm.value.user_ids)
    ) {
      var add_ids = this.pocForm.value.user_ids.filter(
        (x) => this.initial_userIds.indexOf(x) < 0
      );
      var delete_ids = this.initial_userIds.filter(
        (x) => this.pocForm.value.user_ids.indexOf(x) < 0
      );
      await this.http
        .put(Endpoint.API_URL + '' + Endpoint.ASSIGN_USER_CUSTOMER, {
          user_ids_attach: add_ids ?? [],
          user_ids_detach: delete_ids ?? [],
          domain_rfid: this.domainRfId,
        })
        .toPromise()
        .then(async (resp: any) => {
          this.initial_userIds = this.pocForm.value.user_ids;
          alert(resp?.msg);
          // Fetch opportunities based on the selected user
          const opportunities = await this.http
            .get(
              Endpoint.API_URL +
                Endpoint.ASSIGN_USER_CUSTOMER +
                '/' +
                this.selectedUserId
            )
            .toPromise();
        })
        .catch((err) => {
          alert(err.statusText ?? err.msg);
        });
    }
  }
  refreshPage() {
    this.getpocs(null);
  }
  goBack(): void {
    this.location.back();
  }
  viewPOC(poc) {
    this.router.navigate(['poc/poc-details'], {
      state: { poc: poc },
    });
  }
  deletePoc(id: string) {
    if (confirm('Are you sure to delete this POC doc?')) {
      this.http
        .put(Endpoint.API_URL + '' + Endpoint.DELETE_POC + id, {})
        .subscribe((response: any) => {
          this.getpocs(null);
          alert(response.msg);
        });
    }
  }
}
